module.exports = __webpack_public_path__ + "img/appreciateLogoHorizontal.c894777e.png";